module.exports = __webpack_public_path__ + "static/media/StripeLogo.835d1841.png";